import { Controller } from "@hotwired/stimulus";
import {
  createMap,
  fitBounds,
  removeMap,
  addReadOnlyGeomanControls,
} from "../../helpers/map_helpers";

// Connects to data-controller="route-trees--show-map"
export default class extends Controller {
  static targets = ["container"];

  connect() {
    const polygonCoordinates = JSON.parse(this.element.dataset.polygon);
    const routeTree = JSON.parse(this.element.dataset.routeTree);

    this.map = createMap(this.containerTarget);

    const polygonLayer = L.geoJSON(polygonCoordinates).addTo(this.map);

    fitBounds(this.map, [polygonLayer]);

    L.marker(routeTree.coordinates, {
      icon: new L.AwesomeNumberMarkers({
        number: routeTree.tree_number,
        markerColor: "blue",
      }),
    }).addTo(this.map);

    addReadOnlyGeomanControls(this.map);
  }

  disconnect() {
    removeMap(this.map);
    this.map = null;
  }
}
